import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './About.scss';
import { urlFor, client } from '../../client';
import { AppWrap, MotionWrap } from '../../wrapper';
import { TiArrowForwardOutline } from 'react-icons/ti';

const About = () => {
  const [abouts, setAbouts] = useState([]);
  // const [show, setShow] = useState(true);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);
  return (
    <section className="app__about">
      <h2 className="head-text">
        About<span> Me</span>
      </h2>
      <div className="app__profiles">
        {abouts.map((about, index) => {
          const desc = about.description
            .split('-')
            .join('-\n')
            .replaceAll(/-/g, '');
          return (
            <motion.div
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__profile-item"
              key={about.title + index}
            >
              <img
                src={urlFor(about.imgUrl)}
                alt={about.title}
                className="bg-[#F2F3F5]"
              />

              <div className="app__profile-content app__profile-desc">
                {desc.split(/(?<=[.!?])\s+/).map((sentence, i) => (
                  <p key={i} className="text-sm max-sm:ml-2 mb-2">
                    {sentence}
                  </p>
                ))}
                <a
                  href="#contact"
                  className="flex items-center justify-center gap-4 btn cta-btn max-md:mx-auto w-50 text-md max-lg:text-sm max-lg:px-4  bg-white/10 hover:bg-white/20 hover:gap-5 transition-all duration-300"
                >
                  Let's Talk
                  <i className="text-2xl hover:ml-1">
                    <TiArrowForwardOutline />
                  </i>
                </a>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
